import { PayrunPrepare } from "@xemplo/payrun-prepare";
import styled from "styled-components";

const PayrunPrepareStyled = styled(PayrunPrepare)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  flex: 1 0 0;
  margin-top: -60px;
`;

export interface PreparePayrunProps {
  payrunId: string;
  callbackEvent: () => void;
}

export const PreparePayrun = (props: Readonly<PreparePayrunProps>) => {
  const { payrunId, callbackEvent } = props;
  return (
    <PayrunPrepareStyled
      payrunId={payrunId}
      onSuccessCallback={callbackEvent}
    />
  );
};
